import * as _ from 'lodash';

import { ById } from '../store/normalizedState';

export function updateItemByFunc<T>(state: ById<T>, updater: (i: T) => Partial<T> | any, identifier: string) {
  return {
    ...state,
    [identifier]: { ...(state[identifier] as any), ...(updater(state[identifier]) as any) },
  };
}

export function updateAll<T>(state: ById<T>, items: ById<T>) {
  return items ? Object.keys(items).reduce((s, key) => updateItemByFunc(s, () => items[key], key), state) : state;
}

export function removeId<T>(state: string[], id: string): string[] {
  return state.filter(stateId => stateId !== id);
}

export function mergeArrays(arr1: any[], arr2: any[]) {
  if (!arr2) {
    return arr1;
  }

  if (!arr1) {
    return arr2;
  }

  return _.uniq([...arr1, ...arr2]);
}

export function addAllIds<T>(state: string[], elements: ById<T>): string[] {
  return elements ? mergeArrays(state, Object.keys(elements)) : state;
}

export function removeItem<T>(state: ById<T>, id: string) {
  // eslint-disable-next-line no-param-reassign
  delete state[id];

  return {
    ...state,
  };
}
